import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { ApiService } from '../api/api.service';
import { PlacementReview } from '../models/models.lib';
const { apiUrl } = environment;

export abstract class CasiPlacementReviewService extends BehaviorSubject<Array<any>> {
  public loading: boolean = false;

  constructor(
    private http: HttpClient,
  ) {
    super([]);
  }

  public query(): void {
    this.fetch().subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(): Observable<PlacementReview[]> {
    this.loading = true;

    return this.http.get(encodeURI(`${apiUrl}/placement/review/all`))
      .pipe(
        map((response: any, i) => {
          return <PlacementReview[]>response;
        }),
        map(r => r.map(x => PlacementReview.create(x))),
        tap(() => (this.loading = false))
      )
  }
}


@Injectable({
  providedIn: 'root'
})
export class PlacementReviewService extends CasiPlacementReviewService {
  constructor(
    http: HttpClient,
    private apiService: ApiService
  ) {
    super(http)
  }

  get() {
    return this.apiService.getHttpCall('placement/review/all', 'get');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('placement/review', p, 'add');
  }

  update(id: number, dataItem: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`placement/review/${id}`, dataItem, 'update');
  }

  destroy(id: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`placement/review/${id}`, 'destroy');
  }

  getUnitsOfStudy(): Promise<any> {
    return this.apiService.getHttpCallAsPromise(`placement/review/units`, 'getUnitsOfStudy');
  }
}
